<template>
    <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        :disabled="isFetch || errorState"
    >
        <v-row>
            <v-col cols="4">
                <v-text-field
                        v-model="form.email"
                        label="Электронная почта"
                        :error-messages="errorMessages.email"
                        required
                ></v-text-field>
            </v-col>
            <v-col cols="4">
                <v-text-field
                        v-model="form.phone"
                        label="Телефон"
                        :error-messages="errorMessages.phone"
                        required
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="4">
                <v-text-field
                    v-model="form.position"
                    label="Должность"
                    :error-messages="errorMessages.position"
                    required
                ></v-text-field>
            </v-col>
            <v-col cols="4">
                <v-autocomplete
                    v-model="form.jur_id"
                    :items="jurItems"
                    :loading="jurAutocomplete.isLoading"
                    :search-input.sync="jurAutocomplete.search"
                    label="Юридическое лицо"
                    placeholder="Поиск.... "
                    prepend-icon="mdi-database-search"
                ></v-autocomplete>
            </v-col>
            <v-col cols="4">
                <v-checkbox
                    v-model="form.is_primary"
                    label="Будет ли являться данный контакт основным"
                ></v-checkbox>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="4">
                <v-text-field
                    v-model="form.first_name"
                    label="Имя"
                    :error-messages="errorMessages.first_name"
                    required
                ></v-text-field>
            </v-col>
            <v-col cols="4">
                <v-text-field
                    v-model="form.last_name"
                    label="Фамилия"
                    :error-messages="errorMessages.last_name"
                    required
                ></v-text-field>
            </v-col>
            <v-col cols="4">
                <v-text-field
                    v-model="form.patronymic"
                    label="Отчество"
                    :error-messages="errorMessages.patronymic"
                    required
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="4">
                <v-menu
                    v-model="menuBirthdate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            :error-messages="errorMessages.birthdate"
                            v-model="birthdateFormatted"
                            label="Дата рождения"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="form.birthdate"
                        @input="menuBirthdate = false"
                    ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="4">
                <v-select
                    v-model="form.document_type"
                    :items="selectDocumentTypes"
                    label="Тип документа"
                    :error-messages="errorMessages.document_type"
                ></v-select>
            </v-col>
            <v-col cols="4">
                <v-text-field
                    v-model="form.document_number"
                    label="Номер документа"
                    :error-messages="errorMessages.document_number"
                    required
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="4">
                <v-menu
                    v-model="menuIssueDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            :error-messages="errorMessages.issue_date"
                            v-model="issueDateFormatted"
                            label="Дата выдачи документа"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="form.issue_date"
                        @input="menuIssueDate = false"
                    ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="4">
                <v-text-field
                    v-model="form.issue_org "
                    label="Организация выдавшая документ"
                    :error-messages="errorMessages.issue_org"
                    required
                ></v-text-field>
            </v-col>
            <v-col cols="4">
                <v-text-field
                    v-model="form.issue_id"
                    label="Идентификационный номер выдачи"
                    :error-messages="errorMessages.issue_id"
                    required
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="4">
                <v-text-field
                    v-model="form.registration_address"
                    label="Адрес регистрации"
                    :error-messages="errorMessages.registration_address"
                    required
                ></v-text-field>
            </v-col>
            <v-col cols="4">
                <v-text-field
                    v-model="form.inn"
                    label="ИНН"
                    :error-messages="errorMessages.inn"
                    required
                ></v-text-field>
            </v-col>
            <v-col cols="4">
                <v-text-field
                    v-model="form.snils"
                    label="СНИЛС"
                    :error-messages="errorMessages.snils"
                    required
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-btn
                    :disabled="isFetch || errorState"
                    color="success"
                    class="mr-4"
                    @click="onSave"
                >
                    Сохранить
                </v-btn>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import moment from "moment";
import _ from 'lodash';
export default {
    name: "ContactForm",
    props:{
        initJurId: {
            type: Number,
            default: null,
            required: false
        },
        initContactId: {
            type: Number,
            default: null,
            required: false
        },
    },
    mounted() {
        this.form.jur_id = this.initJurId;
        this.contactId = this.initContactId;
    },
    data(){
        return {
            jurAutocomplete: {
                isLoading:false,
                entries: [],
                model:null,
                search:null
            },
            menuBirthdate:false,
            menuIssueDate:false,
            errorState: false,
            isFetch: false,
            valid: true,
            contactId: null,
            form: {
                email: '',
                phone: '',
                first_name: '',
                last_name: '',
                patronymic: '',
                position: '',
                jur_id: '',
                is_primary: true,
                birthdate: '',
                document_type: '',
                document_number: '',
                issue_date: '',
                issue_org: '',
                issue_id: '',
                registration_address: '',
                inn: '',
                snils: '',
            },
            errorMessages: {}
        }
    },
    watch: {
        contactId(newVal){
            if(newVal){
                this.load(newVal);
            }
        },
        'jurAutocomplete.search': function (newVal){
            if(newVal){
                this.onSearchJur(newVal);
            }
        },
    },
    methods: {
        ...mapActions('notifications', ['SHOW_SUCCESS', 'SHOW_ERROR', 'SHOW_RESPONSE_ERROR']),
        onSearchJur: _.debounce(function (val) {
            this.searchJur(val);
        }, 500),
        async searchJur(val){
            if (this.jurAutocomplete.isLoading) return
            try {
                this.jurAutocomplete.isLoading = true;
                let {data} = await this.getClient().searchJur(val);
                this.jurAutocomplete.entries.splice(0, this.jurAutocomplete.entries.length, ...data.data);
            }catch (e){
                console.log(e);
                this.SHOW_RESPONSE_ERROR({errorResponse: e, defaultError: 'Ошибка поиска ('});
                if(e.response && e.response.data && e.response.data.errors){
                    this.setErrorMessages(e.response.data.errors);
                }
            }finally {
                this.jurAutocomplete.isLoading = false;
            }
        },
        async load(contactId){
            try {
                this.isFetch = true;
                let {data} = await this.getClient().getContact(contactId, 'jur');
                this.setFormFields(data);
                this.$emit('loaded', data);
            }catch (e){
                console.log(e);
                this.SHOW_RESPONSE_ERROR({errorResponse: e, defaultError: 'Ошибка при загрузке контакта ('});
                if(e.response && e.response.data && e.response.data.errors){
                    this.setErrorMessages(e.response.data.errors);
                }
                this.errorState = true;
            }finally {
                this.isFetch = false;
            }
        },
        async onSave(){
            this.setErrorMessages({});
            if('create' === this.formState){
                await this.create();
            }else{
                await this.update();
            }
        },
        async create(){
            try {
                this.isFetch = true;
                let {data} = await this.getClient().contactCreate(this.form);
                this.$emit('created', data);
                this.setFormFields(data);
                this.SHOW_SUCCESS('Успешно создано');
            }catch (e){
                this.SHOW_RESPONSE_ERROR({errorResponse: e, defaultError: 'Ошибка при создании контакта ('});
                if(e.response && e.response.data && e.response.data.errors){
                    this.setErrorMessages(e.response.data.errors);
                }
            }finally {
                this.isFetch = false;
            }
        },
        async update(){
            try {
                this.isFetch = true;
                let {data} = await this.getClient().contactUpdate(this.contactId, this.form);
                // this.setFormFields(data);
                this.$emit('updated', data);
                this.SHOW_SUCCESS('Успешно обновлено');
                this.load(this.contactId);
            }catch (e){
                this.SHOW_RESPONSE_ERROR({errorResponse: e, defaultError: 'Ошибка при обновлении контакта ('});
                if(e.response && e.response.data && e.response.data.errors){
                    this.setErrorMessages(e.response.data.errors);
                }
            }finally {
                this.isFetch = false;
            }
        },
        setErrorMessages(errorMessages){
            this.errorMessages = Object.assign({}, {}, errorMessages);
        },
        setFormFields(form){
            if(form.client){
               for (let field in form.client){
                   if(field in this.form){
                       if(['birthdate', 'issue_date'].includes(field) && null != form.client[field]){
                           this.form[field] = moment(form.client[field]).format('YYYY-MM-DD')
                           continue;
                       }
                       this.form[field] = form.client[field];
                   }
               }
            }
            this.form.position = form.position;
            this.form.email = form.default_email;
            this.form.phone = form.default_phone;
            if(form.jur){
                this.jurAutocomplete.entries.splice(0, this.jurAutocomplete.entries.length, form.jur);
            }
        },
    },
    computed: {
        ...mapGetters( 'contragents', ['getClient']),
        formState(){
            if(null === this.contactId){
                return 'create';
            }
            return 'update';
        },
        selectDocumentTypes(){
            return [
                {text: 'Не выбран', value: null},
                {text: 'Паспорт', value: 'passport'},
                {text: 'Водительское удостоверение', value: 'driver_license'},
                {text: 'Другой', value: 'other'},
            ];
        },
        birthdateFormatted(){
            return this.form.birthdate ? moment(this.form.birthdate).format('DD.MM.YYYY') : null;
        },
        issueDateFormatted(){
            return this.form.issue_date ? moment(this.form.issue_date).format('DD.MM.YYYY') : null;
        },
        jurItems(){
            return this.jurAutocomplete.entries.map((jur) => {
                return {
                    text: jur.short_name,
                    value: jur.id
                };
            });
        }
    }
}
</script>

<style scoped>

</style>